import { useContext } from "react";
import { Image } from 'office-ui-fabric-react/lib/Image';
import { DefaultButton, Stack, Text, Separator } from 'office-ui-fabric-react';
import { Link, useHistory } from "react-router-dom";
import logo_dark from '@/images/logo_dark.svg';
// import logo_cnmv from '@/images/cnmv.png';
import logo_diaphanum from '@/images/diaphanum.png';
import logo_fintech from '@/images/fintech.png';
import { connect } from 'react-redux';
import { ThemeContext } from '@fluentui/react-theme-provider';
import SocialNetworksLinks from './SocialNetworksLinks';
import { StyledFooter, FooterLayoutStyle, StyledClientWarning } from './FooterStyles';
import React from "react";

function mapStateToProps(state: any)
{
    return{ footerVisible: state.ui.footerVisible };
}

const Footer = (props: any) =>
{
    let history = useHistory();
    const theme = useContext(ThemeContext);
    const themeName = (theme?.palette as {name?: string} | undefined)?.name ?? "light";

    const handleHomeButtonClick = () =>
    {
        history.push("/");
    }

    if(!props.footerVisible)
    {
        return (<></>);
    }

    return(
        <React.Fragment>
            <FooterLayoutStyle />
            <StyledFooter themeName={themeName}>
                <div className="ms-Grid-row footer-container">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4">
                        <div className="footprint">
                            <DefaultButton className="home-link" title="Página principal" onClick={handleHomeButtonClick}>
                                <Image src={logo_dark} alt="IronIA logotipo" />
                            </DefaultButton>
                            <Text className="slogan">Libertad para invertir</Text>
                            <Separator className="separator" />
                            <Text className="copyright">&copy;{new Date().getFullYear()} by IronIA Fintech</Text>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4">
                        <Text className="titleSede">
                            Simplicitas Capital SL, marca IronIA Fintech, agente exclusivo de 
                            <a href='https://www.diaphanum.es/' target='_blank' rel='noopener noreferrer'>
                                &nbsp;Diaphanum Valores SV SAU
                            </a>, entidad autorizada y supervisada por CNMV con domicilio en 
                            C/María de Molina 40, 28006 Madrid, a través de nuestro correo electrónico&nbsp;
                            <a href='mailto:info@ironia.tech' title='Correo electrónico de contacto'>
                                <span>info@ironia.tech</span>
                            </a>.
                        </Text>
                        <Text className="title">Links de interés</Text>
                        <Stack verticalAlign="start" className="links">
                            <Link to="/Legal" target="_blank" rel="noopener noreferrer">
                                <Text>Aviso Legal</Text>
                            </Link>
                            <a href="https://www.linkedin.com/company/ironia-fintech/people/" target="_blank" rel="noopener noreferrer">
                                <Text>Nuestro equipo</Text>
                            </a>
                            <a href="https://www.linkedin.com/company/ironia-fintech/jobs/" target="_blank" rel="noopener noreferrer">
                                <Text>Careers</Text>
                            </a>
                            <a href="https://blog.ironia.tech" target="_blank" rel="noopener noreferrer">
                                <Text>Blog</Text>
                            </a>
                        </Stack>
                        <Text className="title">Síguenos en nuestras redes sociales:</Text>
                        <SocialNetworksLinks />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4">
                        <StyledClientWarning>
                            IronIA informa a sus clientes que, conforme a estándares de mercado generalmente aceptados, la
                            puesta a disposición del espacio publicitario en nuestra plataforma a gestoras de fondo de
                            inversión está sujeto a los costes operativos y publicitarios pertinentes; dichos costes son
                            íntegramente sufragados por las gestoras de fondos sin repercusión a nuestros clientes. En
                            ningún caso dichos costes tienen la consideración de <i>"platform fees"</i> o comisiones variables
                            pagadas periódicamente por la gestora de la IIC a IronIA como un porcentaje del volumen
                            intermediado, ni están directamente ligados a la prestación de un servicio de inversión al
                            cliente por IronIA o las entidades de su grupo o relacionadas o vinculadas al patrimonio del
                            fondo que la plataforma pueda haber intermediado para sus clientes finales.
                        </StyledClientWarning>
                        <Text className="title">Información Adicional:</Text>
                        <div className="related-entities">
                            <div className="related-entities-row">
                                <div className="related-entities-col-diaphanum">
                                    <a href="https://www.diaphanum.es/" target="_blank" rel="noopener noreferrer">
                                        <Image src={logo_diaphanum} alt="Diaphanum" />
                                    </a>
                                </div>
                                <div className="related-entities-col-fintech related-entities-col-fintech-desktop">
                                    <a href="https://www.asociacionfintech.es/" target="_blank" rel="noopener noreferrer">
                                        <Image src={logo_fintech} alt="FINTECH e INSURTECH" />
                                    </a>
                                </div>
                                <div className="related-entities-col-fintech related-entities-col-fintech-mobile">
                                    <a href="https://www.asociacionfintech.es/" target="_blank" rel="noopener noreferrer">
                                        <Image src={logo_fintech} alt="FINTECH e INSURTECH" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </StyledFooter>
        </React.Fragment>
    )
};

export default connect(mapStateToProps)(Footer);